export const NOT_AVAILABLE = "NA";

export function pushDataLayer(payload: Record<string, unknown>): void {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(payload);
}

export function getPlatform(): "mweb" | "web" {
  if (typeof navigator === "undefined") return "web";

  return /android|ipad|iphone|ipod|mobi/i.test(navigator.userAgent)
    ? "mweb"
    : "web";
}
